const FETCH_CONTRACTS = 'fetch_contracts';
const FETCH_CONTRACT_DOCS = 'fetch_contract_docs';
const FETCH_CONTRACTS_TOTALS = 'fetch_contracts_totals';
const DELETE_CONTRACT = 'delete_contract';
const FETCH_CONTRACT = 'fetch_contract';
const CREATE_CONTRACT = 'create_contract';
const PERSIST_CONTRACT = 'persist_contract';
const SEND_CONTRACT_TO_DOCUSIGN = 'send_contract_to_docusign';
const REMIND_CONTRACT_TO_DOCUSIGN = 'remind_contract_to_docusign';

export default {
    FETCH_CONTRACTS,
    FETCH_CONTRACT_DOCS,
    FETCH_CONTRACTS_TOTALS,
    DELETE_CONTRACT,
    FETCH_CONTRACT,
    CREATE_CONTRACT,
    PERSIST_CONTRACT,
    SEND_CONTRACT_TO_DOCUSIGN,
    REMIND_CONTRACT_TO_DOCUSIGN,
};
